module.exports = __webpack_public_path__ + "static/media/cover4.ada370a2.png";